module.exports = __webpack_public_path__ + "static/media/26.4a30430c.jpg";